import { storage } from '@/Services/Storage'

export default {
    methods: {
        getInstance() {
            let api_config = storage.get('api_config')
            api_config = JSON.parse(api_config)

            return api_config && api_config.instance ? api_config.instance : ''
        },

        parseJwt(token) {
            var base64Url = token.split('.')[1]
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
            var jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map(function(c) {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                    })
                    .join('')
            )

            return JSON.parse(jsonPayload)
        },

        randomId() {
            let x = () => {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1)
            }
            return x() + x() + '-' + x() + '-' + x() + x() + x()
        },

        currencyBRL(num) {
            const formated = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
            }).format(num)

            return formated
        },

        slugify(text) {
            return text
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim()
                .replace(/\s+/g, '-')
                .replace(/[^\w-]+/g, '')
                .replace(/--+/g, '-')
        },
    },
}
